/* ULTRA REACT – zachowanie strony Maski ULTRA */
(function () {
  'use strict';
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var reduced = mq('(prefers-reduced-motion: reduce)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    cents = Math.round(cents);
    var whole = cents % 100 === 0;
    return (cents / 100).toLocaleString('pl-PL', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }) + ' zł';
  }
  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (window.UltraMask3D) return res();
      var s = document.createElement('script');
      s.src = src; s.async = true; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function initRoot(root) {
    if (root.__urInit) return;
    root.__urInit = true;
    var maskId = +root.getAttribute('data-mask-variant');
    var maskPrice = +root.getAttribute('data-mask-price') || 0;

    /* ---------- logo ULTRA w nagłówku sklepu ---------- */
    if (root.hasAttribute('data-swap-header')) {
      var tpl = $('[data-ur-logo-tpl]', root);
      var slot = document.querySelector('.header__heading-logo-wrapper, .header__heading-link, .header__heading, .site-header__logo');
      if (tpl && slot && !slot.__urSwapped) {
        var imgs = slot.tagName === 'IMG' ? [slot] : $$('img, svg', slot);
        if (imgs.length) {
          imgs.forEach(function (el, i) { if (i === 0) { el.replaceWith(tpl.content.cloneNode(true)); } else { el.style.display = 'none'; } });
          slot.__urSwapped = true;
        }
      }
    }

    /* ---------- pojawianie się przy przewijaniu ---------- */
    var reveals = $$('.ur-reveal', root);
    if (!reduced && 'IntersectionObserver' in window) {
      root.classList.add('ur--anim');
      var rio = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el, i) { el.style.setProperty('--d', (i % 4) * 70 + 'ms'); rio.observe(el); });
    }

    /* ---------- galeria ---------- */
    var gal = $('[data-ur-gallery]', root);
    if (gal) {
      var track = $('[data-track]', gal);
      var slides = $$('[data-slide]', gal);
      var dots = $$('[data-dot]', gal);
      var cur = 0;
      var go = function (i) {
        cur = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[cur].offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      };
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-dot')); }); });
      var graf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(graf);
        graf = requestAnimationFrame(function () {
          var w = track.clientWidth || 1;
          var n = Math.round(track.scrollLeft / w);
          if (n !== cur) {
            var v = $('video', slides[cur]);
            if (v && !v.paused) v.pause();
          }
          cur = n;
          dots.forEach(function (d, k) {
            var on = k === cur;
            d.classList.toggle('is-active', on);
            if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
            if (on && d.parentNode.scrollWidth > d.parentNode.clientWidth) {
              d.parentNode.scrollTo({ left: d.offsetLeft - d.parentNode.clientWidth / 2 + d.clientWidth / 2, behavior: 'smooth' });
            }
          });
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); }
      });
    }

    /* ---------- film: odtwarzaj tylko gdy widoczny ---------- */
    $$('.ur-film video, .ur-night video', root).forEach(function (v) {
      v.muted = true;
      if (reduced) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; return; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () { v.controls = true; }); }
            else v.pause();
          });
        }, { threshold: 0.25 }).observe(v);
      }
    });

    /* ---------- pętla zmiany koloru w sekcji "Jak to działa" ---------- */
    var morph = $('[data-morph]', root);
    if (morph && $('.ur-how__img--warm', morph)) {
      var warm = false, mtimer = 0, mvis = true;
      var step = function () { warm = !warm; morph.classList.toggle('is-warm', warm); };
      var startM = function () { if (!mtimer) { mtimer = setInterval(function () { if (mvis) step(); }, 3400); setTimeout(function () { if (mvis) step(); }, 900); } };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { mvis = en[0].isIntersecting; if (mvis) startM(); }, { threshold: 0.15 }).observe(morph);
      } else startM();
    }

    /* ---------- stan zakupu: maska + opcjonalny laser ---------- */
    var qtyInput = $('[data-qty] input', root);
    var addon = $('[data-addon]', root);
    var totalEl = $('[data-total]', root);
    var stickyTotal = $('[data-sticky-total]', root);
    var atcLabel = $('[data-atc-label]', root);
    var laser = null;

    function qty() { return Math.max(1, Math.min(10, parseInt(qtyInput && qtyInput.value, 10) || 1)); }
    function refreshTotals() {
      var sum = maskPrice * qty() + (laser ? laser.price : 0);
      var txt = money(sum);
      if (totalEl) totalEl.textContent = txt;
      if (stickyTotal) stickyTotal.textContent = laser ? txt + ' z laserem' : txt;
      if (atcLabel && !$('[data-atc]', root).hasAttribute('data-soldout')) {
        atcLabel.textContent = laser ? 'Dodaj zestaw do koszyka' : 'Dodaj do koszyka';
      }
    }
    function setLaser(l, from) {
      laser = l;
      if (addon && from !== 'addon') {
        addon.value = l ? String(l.id) : '';
        if (l && addon.value !== String(l.id)) addon.value = '';
      }
      syncCards();
      refreshTotals();
    }

    $$('[data-qty-minus]', root).forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); refreshTotals(); }); });
    $$('[data-qty-plus]', root).forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.min(10, qty() + 1); refreshTotals(); }); });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); refreshTotals(); });
    if (addon) addon.addEventListener('change', function () {
      var o = addon.options[addon.selectedIndex];
      setLaser(addon.value ? { id: +addon.value, price: +o.getAttribute('data-price'), name: o.getAttribute('data-name') } : null, 'addon');
    });

    /* ---------- karta zestawu ---------- */
    var set = $('[data-set]', root);
    var cards = set ? $$('[data-card]', set) : [];
    var setBtn = set && $('[data-set-add]', set);
    var setThumb = set && $('[data-set-thumb]', set);
    var setName = set && $('[data-set-name]', set);
    var setSum = set && $('[data-set-sum]', set);
    function cardVariant(card) {
      var el = $('[data-card-variant]', card);
      var src = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
      return { id: +el.value, price: +src.getAttribute('data-price'), name: src.getAttribute('data-name') };
    }
    function syncCards() {
      if (!set) return;
      var active = null;
      cards.forEach(function (c) {
        var ids = $$('[data-card-variant] option', c).map(function (o) { return +o.value; });
        var single = $('input[data-card-variant]', c);
        if (single) ids = [+single.value];
        var on = !!laser && ids.indexOf(laser.id) !== -1;
        if (on) {
          var sel = $('select[data-card-variant]', c);
          if (sel && +sel.value !== laser.id) sel.value = String(laser.id);
          active = c;
        }
        c.classList.toggle('is-picked', on);
        $('[data-card-pick]', c).setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (laser) {
        setName.textContent = laser.name;
        setSum.textContent = money(maskPrice + laser.price);
        var img = active && $('.ur-card__img img', active);
        setThumb.innerHTML = img ? '<img src="' + (img.currentSrc || img.src).replace(/"/g, '') + '" alt="" width="56" height="56">' : '';
        setThumb.classList.add('is-set');
        setBtn.disabled = false;
        setBtn.textContent = 'Dodaj zestaw · ' + money(maskPrice + laser.price);
      } else {
        setName.textContent = 'UltraLaser';
        setSum.textContent = money(maskPrice);
        setThumb.innerHTML = '<em>Wybierz laser</em>';
        setThumb.classList.remove('is-set');
        setBtn.disabled = true;
        setBtn.textContent = 'Wybierz laser powyżej';
      }
    }
    cards.forEach(function (c) {
      $('[data-card-pick]', c).addEventListener('click', function () {
        var v = cardVariant(c);
        setLaser(laser && laser.id === v.id ? null : v);
      });
      var sel = $('select[data-card-variant]', c);
      if (sel) sel.addEventListener('change', function () {
        if (c.classList.contains('is-picked')) setLaser(cardVariant(c));
      });
    });

    /* ---------- koszyk ---------- */
    var atc = $('[data-atc]', root);
    var msg = $('[data-msg]', root);
    var setMsgEl = set && $('[data-set-msg]', set);
    var busy = false;
    function say(el, text, kind) {
      if (!el) return;
      el.hidden = !text;
      el.textContent = text || '';
      el.className = el.className.replace(/\s?is-(ok|error)/g, '') + (kind ? ' is-' + kind : '');
    }
    function buttons() { return [atc, setBtn].concat($$('[data-atc-proxy]', root)).filter(Boolean); }
    buttons().forEach(function (b) { if (b.disabled && b !== setBtn) b.setAttribute('data-soldout', ''); });
    function setBusy(on) {
      busy = on;
      buttons().forEach(function (b) {
        if (on) { b.setAttribute('aria-busy', 'true'); b.disabled = true; }
        else {
          b.removeAttribute('aria-busy');
          b.disabled = b.hasAttribute('data-soldout') || (b === setBtn && !laser);
        }
      });
    }
    function openDrawer(json) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && json && json.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(json);
        return true;
      }
      return false;
    }
    function add(items, msgEl) {
      if (busy) return;
      say(msg, ''); say(setMsgEl, '');
      setBusy(true);
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          setBusy(false);
          if (!res.ok || res.json.status) {
            say(msgEl, res.json.description || res.json.message || 'Nie udało się dodać do koszyka. Spróbuj ponownie.', 'error');
            return;
          }
          document.dispatchEvent(new CustomEvent('ur:added', { detail: res.json }));
          if (!openDrawer(res.json)) window.location.href = base + 'cart';
          else say(msgEl, 'Dodano do koszyka.', 'ok');
        })
        .catch(function () {
          setBusy(false);
          say(msgEl, 'Brak połączenia. Sprawdź internet i spróbuj ponownie.', 'error');
        });
    }
    function buyMain() {
      var items = [{ id: maskId, quantity: qty() }];
      if (laser) items.push({ id: laser.id, quantity: 1 });
      add(items, msg);
    }
    var form = $('[data-ur-form]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); buyMain(); });
    $$('[data-atc-proxy]', root).forEach(function (b) { b.addEventListener('click', buyMain); });
    if (setBtn) setBtn.addEventListener('click', function () {
      if (!laser) return;
      add([{ id: maskId, quantity: 1 }, { id: laser.id, quantity: 1 }], setMsgEl);
    });
    refreshTotals();
    syncCards();

    /* ---------- stały pasek zakupu ---------- */
    var sticky = $('[data-sticky]', root);
    var finalSec = $('.ur-final', root);
    if (sticky && atc) {
      var stOn = null, sraf = 0;
      var upd = function () {
        sraf = 0;
        var vh = window.innerHeight;
        var a = atc.getBoundingClientRect();
        var f = finalSec ? finalSec.getBoundingClientRect() : null;
        var hide = (f && f.top < vh * 0.7 && f.bottom > vh * 0.3) || (setBtn && (function () { var r = setBtn.getBoundingClientRect(); return r.top < vh && r.bottom > 0; })());
        var on = a.bottom < 0 && !hide;
        if (on === stOn) return;
        stOn = on;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', sticky).forEach(function (btn) { btn.tabIndex = on ? 0 : -1; });
      };
      var req = function () { if (!sraf) sraf = requestAnimationFrame(upd); };
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      upd();
    }

    /* ---------- lekkie pochylenie zdjęć przy kursorze ---------- */
    if (!reduced && mq('(hover: hover) and (pointer: fine)')) {
      $$('.ur-tilt, .ur-card', root).forEach(function (el) {
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          el.style.setProperty('--rx', (-y * 5).toFixed(2) + 'deg');
          el.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg');
        });
        el.addEventListener('pointerleave', function () { el.style.removeProperty('--rx'); el.style.removeProperty('--ry'); });
      });
    }

    /* ---------- model 3D ---------- */
    var stage = $('[data-stage]', root);
    var view = stage && $('[data-ur3d]', stage);
    if (view) {
      var viewer = null;
      var cover = $('[data-cover]', stage), cbar = $('[data-cover-bar]', stage);
      var hint = $('[data-hint-text]', stage), spin = $('[data-spin]', stage);
      var scrub = $('[data-scrub]', stage), ticks = $('[data-ticks]', stage);
      var fine = mq('(hover: hover) and (pointer: fine)');
      var texts = {
        heat: fine ? 'Przytrzymaj przycisk myszy na masce i przesuwaj' : 'Przytrzymaj palec na masce i przesuwaj',
        rotate: fine ? 'Przeciągnij maskę, żeby ją obrócić' : 'Przeciągnij palcem, żeby obrócić maskę'
      };
      var setHint = function (m) { if (hint) hint.textContent = texts[m] || texts.heat; };
      setHint('heat');
      var boot3d = function () {
        loadScript(view.getAttribute('data-src')).then(function () {
          viewer = window.UltraMask3D.mount(view, {});
          if (!viewer) { stage.classList.add('is-used'); return; }
          viewer.canvas.addEventListener('pointerdown', function () { stage.classList.add('is-used'); });
          if (spin) spin.setAttribute('aria-pressed', viewer.isSpinning() ? 'true' : 'false');
          setHint(stage.getAttribute('data-mode') || 'heat');
        }).catch(function () { view.classList.add('ur3d--nogl'); });
      };
      view.addEventListener('ultra3d:heat', function (e) {
        var c = Math.round((e.detail.cover || 0) * 100);
        if (cover) cover.textContent = c + '%';
        if (cbar) cbar.style.width = c + '%';
        if (c > 0) stage.classList.add('is-used');
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); boot3d(); } }, { rootMargin: '400px 0px' });
        io.observe(stage);
      } else boot3d();

      var flashEl = $('.ur-stage__flash', stage);
      $$('button[data-mode]', stage).forEach(function (b) {
        b.addEventListener('click', function () {
          var m = b.getAttribute('data-mode');
          $$('button[data-mode]', stage).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          stage.setAttribute('data-mode', m);
          setHint(m);
          if (viewer) viewer.setMode(m);
        });
      });
      $$('button[data-light]', stage).forEach(function (b) {
        b.addEventListener('click', function () {
          var l = b.getAttribute('data-light');
          $$('button[data-light]', stage).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          stage.setAttribute('data-light', l);
          if (viewer) viewer.setLight(l);
        });
      });
      $$('[data-act]', stage).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!viewer) return;
          var a = b.getAttribute('data-act');
          if (a === 'flash') {
            viewer.flash();
            if (flashEl && !reduced) { flashEl.classList.remove('is-on'); void flashEl.offsetWidth; flashEl.classList.add('is-on'); }
          }
          if (a === 'warm') viewer.warmAll();
          if (a === 'cool') viewer.coolAll();
        });
      });
      if (spin) spin.addEventListener('click', function () {
        if (!viewer) return;
        var on = !viewer.isSpinning();
        viewer.setSpin(on);
        spin.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (scrub) {
        var drag = null, off = 0;
        var move = function (dx) {
          if (!viewer) return;
          viewer.rotateBy(dx * 0.012);
          off += dx;
          if (ticks) ticks.style.backgroundPosition = off + 'px 0';
          scrub.setAttribute('aria-valuenow', String(Math.round(((off * 0.012 * 180 / Math.PI) % 360 + 360) % 360)));
        };
        scrub.addEventListener('pointerdown', function (e) {
          if (!viewer) return;
          drag = { x: e.clientX, t: performance.now(), vx: 0 };
          try { scrub.setPointerCapture(e.pointerId); } catch (x) {}
          if (viewer.isSpinning()) { viewer.setSpin(false); spin.setAttribute('aria-pressed', 'false'); }
          stage.classList.add('is-used');
          e.preventDefault();
        });
        scrub.addEventListener('pointermove', function (e) {
          if (!drag) return;
          var dx = e.clientX - drag.x, now = performance.now();
          drag.vx = dx / Math.max(now - drag.t, 8) * 1000;
          drag.x = e.clientX; drag.t = now;
          move(dx);
        });
        var up = function () {
          if (!drag) return;
          if (viewer && Math.abs(drag.vx) > 60) viewer.fling(drag.vx * 0.012 * 0.5);
          drag = null;
        };
        scrub.addEventListener('pointerup', up);
        scrub.addEventListener('pointercancel', up);
        scrub.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { move(-20); e.preventDefault(); }
          if (e.key === 'ArrowRight') { move(20); e.preventDefault(); }
        });
      }
    }
  }

  function boot() { $$('[data-ur]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
